// extracted by mini-css-extract-plugin
export default {"modal":"vgRIHgIZHVWF2Tsy6Zjz","reportModal":"mRmwTT9fhZJ4S5TpTxBk","modalWrapper":"Ix17iGr_ODRyehbOJ_zJ","reportModalBackground":"uHaoFuo0abP0KJAjS9ru"};